var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{attrs:{"id":"full-report-hmc-theme"}},[_c('div',{staticStyle:{"width":"100%","height":"600px","border":"1px solid black"},attrs:{"id":"pdf-preview"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }